/* Optional Supabase auth (magic link). Active only when the env vars are set
 * (apps/web/.env.local); without them the game keeps the anonymous token login.
 * The Supabase session lives in localStorage via supabase-js; the game server
 * receives only the short-lived access token inside `hello` and verifies it. */
import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const url = import.meta.env['VITE_SUPABASE_URL'] as string | undefined;
const anonKey = import.meta.env['VITE_SUPABASE_ANON_KEY'] as string | undefined;

export const supabase: SupabaseClient | null = url && anonKey ? createClient(url, anonKey) : null;

/** Set when the user arrives via a password-recovery link; the account panel
 * shows the "set new password" form until it is cleared. */
let recoveryPending = false;
supabase?.auth.onAuthStateChange((event) => {
  if (event === 'PASSWORD_RECOVERY') recoveryPending = true;
});

export function isRecoveryPending(): boolean {
  return recoveryPending;
}

export function clearRecoveryPending(): void {
  recoveryPending = false;
}

export async function getAccessToken(): Promise<string | null> {
  if (!supabase) return null;
  try {
    const { data } = await supabase.auth.getSession();
    return data.session?.access_token ?? null;
  } catch {
    return null;
  }
}
